import { render, staticRenderFns } from "./ManualOrder.vue?vue&type=template&id=167ea98b"
import script from "./ManualOrder.vue?vue&type=script&lang=js"
export * from "./ManualOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports